import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {ShoppingBag} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {type ProductData} from "../../../../types/product";

interface ProductFormProps {
    productData: ProductData;
    onChange: (data: ProductData) => void;
}

export function ProductForm({productData, onChange}: ProductFormProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-6 py-4">
            <div className="flex items-center gap-3 pb-4 border-b">
                <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <ShoppingBag className="h-6 w-6 text-primary"/>
                </div>
                <div>
                    <p className="text-muted-foreground">{t('admin.products.create.configureDetails')}</p>
                </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                    <Label htmlFor="productName">{t('admin.products.create.form.name.label')}</Label>
                    <Input
                        id="productName"
                        value={productData.name}
                        onChange={(e) => onChange({...productData, name: e.target.value})}
                        placeholder={t('admin.products.create.form.name.placeholder')}
                    />
                </div>

                <div className="space-y-2">
                    <Label htmlFor="stripeProductId">{t('admin.products.create.form.stripeId.label')}</Label>
                    <Input
                        id="stripeProductId"
                        value={productData.stripeProductId}
                        onChange={(e) => onChange({...productData, stripeProductId: e.target.value})}
                        placeholder={t('admin.products.create.form.stripeId.placeholder')}
                    />
                </div>

                <div className="space-y-2">
                    <Label
                        htmlFor="softwareDurationDays">{t('admin.products.create.form.softwareDurationDays.label')}</Label>
                    <Input
                        id="softwareDurationDays"
                        type="number"
                        value={productData.softwareDurationDays || ''}
                        onChange={(e) => onChange({
                            ...productData,
                            softwareDurationDays: e.target.value ? parseInt(e.target.value) : undefined
                        })}
                        placeholder={t('admin.products.create.form.softwareDurationDays.placeholder')}
                    />
                </div>

                <div className="space-y-2 md:col-span-2">
                    <Label htmlFor="productDescription">{t('admin.products.create.form.description.label')}</Label>
                    <Input
                        id="productDescription"
                        value={productData.description}
                        onChange={(e) => onChange({...productData, description: e.target.value})}
                        placeholder={t('admin.products.create.form.description.placeholder')}
                    />
                </div>
            </div>
        </div>
    );
}